import React from 'react';
import Star from '@assets/icons/star';
import Square from '@assets/icons/square';
import SquareCheck from '@assets/icons/square-check';
import { levelNameMultiple } from '@utils/helpers/levelName';
import { useAtom, useSetAtom } from 'jotai';
import { selectedBreakdownIdAtom } from '@components/progress/ProgressStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { atomWithStorage } from 'jotai/utils';

export interface ITableItemSkillLevel {
  id: number | string;
  topic: string;
  level: string;
  skillLevel: number;
  checked: boolean;
  color?: string;
  progress?: number;
}

export interface TableItemV2Props extends ITableItemSkillLevel {
  onCheckboxClick: (id: number | string, newStatus: boolean) => void;
}

const stepAtom = atomWithStorage('new-progress-step', 0);
const TableItemV2 = (props: TableItemV2Props) => {
  const [selectedBreakdownId, setSelectedBreakdownId] = useAtom(
    selectedBreakdownIdAtom,
  );
  const setStepOnboarding = useSetAtom(stepAtom);

  function handleClickLabel() {
    setSelectedBreakdownId(Number(props.id));
    setStepOnboarding(1);
  }

  return (
    <div
      className={
        'flex px-4 gap-4 text-md first-of-type:mt-2 py-2 max-md:items-start md:items-center rounded-2xl hover:bg-primary-navyblue-shade/[0.65] ' +
        (selectedBreakdownId === Number(props.id) &&
          '!bg-primary-navyblue-shade')
      }
      data-testid={'table-item'}
    >
      <div
        className={'flex-initial cursor-pointer max-md:mt-1'}
        onClick={() => props.onCheckboxClick(props.id, !props.checked)}
        data-testid={'checkbox' + props.id}
      >
        {props.checked ? (
          <SquareCheck
            className={'w-6'}
            fill={props.color}
            data-testid={'checked' + props.id}
          />
        ) : (
          <Square
            className={'fill-current text-neutral-chalk w-6'}
            data-testid={'unchecked' + props.id}
          />
        )}
      </div>
      <div
        onClick={handleClickLabel}
        data-testid={'topic-label-' + props.id}
        className={
          'flex gap-4 w-full items-start md:items-center cursor-pointer topic-label'
        }
        id={'topic-label-' + props.id}
      >
        <div
          className={'flex-auto leading-6'}
          style={props.checked && props.color ? { color: props.color } : {}}
        >
          {props.topic}
          <div
            className={
              'hidden max-md:block text-xs text-neutral-eraser leading-3 mt-2'
            }
          >
            {levelNameMultiple(props.level, false)}
          </div>
        </div>
        <div className={'flex-none text-center w-20 max-md:hidden'}>
          {levelNameMultiple(props.level)}
        </div>
        <div
          className={'flex-none text-center w-24'}
          data-testid={'mastery' + props.id}
        >
          {(props.progress || 0) > 0 ? (
            <FontAwesomeIcon
              icon={faCaretUp}
              className={
                props.skillLevel == 10
                  ? 'text-alert-success mr-3 ml-2'
                  : 'text-alert-success mr-3'
              }
            />
          ) : (
            <span className={'mr-[24px]'}></span>
          )}
          <span
            className={
              props.progress == 0 && props.skillLevel == 10 ? 'ml-2' : ''
            }
          >
            {props.skillLevel > 0 ? props.skillLevel.toFixed(0) : '-'}
          </span>
          <Star
            className={
              'fill-current text-alert-warning w-4 inline-block ml-1 align-baseline'
            }
          />
        </div>
      </div>
    </div>
  );
};

export default TableItemV2;
